
export default function SubmissionGuidelines() {
  const guidelines = [
    {
      icon: 'ri-map-pin-line',
      title: 'Roseville Events Only',
      desc: 'Events must take place in or around Roseville, CA to be listed on our calendar.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Review Process',
      desc: 'All submissions are reviewed by our team within 24 hours before going live.',
    },
    {
      icon: 'ri-image-line',
      title: 'Include a Photo',
      desc: 'Events with images get significantly more clicks. Provide a high-quality image URL.',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Submit Early',
      desc: 'Submit at least 3 days before your event for best visibility on the calendar.',
    },
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
          <i className="ri-information-line text-teal-600 text-lg"></i>
          Submission Guidelines
        </h3>
        <ul className="space-y-4">
          {guidelines.map((g) => (
            <li key={g.title} className="flex gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg shrink-0">
                <i className={`${g.icon} text-teal-600`}></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800">{g.title}</p>
                <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">{g.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-teal-50 rounded-2xl border border-teal-100 p-6">
        <h3 className="text-base font-bold text-gray-900 mb-2 flex items-center gap-2">
          <i className="ri-rocket-line text-teal-600 text-lg"></i>
          Want More Visibility?
        </h3>
        <p className="text-sm text-gray-600 mb-4 leading-relaxed">
          Upgrade to a promoted listing to appear at the top of the calendar, in our newsletter, and on the homepage.
        </p>
        <a
          href="/promote-event"
          className="inline-flex items-center gap-2 bg-teal-600 text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-star-line"></i>
          Promote Your Event
        </a>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <h3 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
          <i className="ri-question-line text-teal-600 text-lg"></i>
          Questions?
        </h3>
        <p className="text-sm text-gray-600 mb-3 leading-relaxed">
          Need help with your submission or have a question about event listings?
        </p>
        <a
          href="mailto:info@roseville.org"
          className="inline-flex items-center gap-2 text-teal-600 text-sm font-medium hover:text-teal-700 transition-colors"
        >
          <i className="ri-mail-line"></i>
          info@roseville.org
        </a>
      </div>
    </div>
  );
}
